/* eslint-disable no-useless-escape */
$.extend($.validator.messages, {
  required: 'Поле обязательно для заполнения',
  remote: 'Введите правильное значение',
  email: 'Введите корректную электронную почту',
  url: 'Введите корректный URL',
  date: 'Введите корректную дату',
  dateISO: 'Введите корректную дату в формате ISO',
  number: 'Введите число',
  digits: 'Вводите только цифры',
  letters: 'Вводите только буквы',
  creditcard: 'Введите правильный номер кредитной карты',
  equalTo: 'Пароли не совпадают',
  extension: 'Выберите файл с правильным расширением',
  maxlength: $.validator.format('Максимальная длина описания - {0} символов'),
  minlength: $.validator.format('Введите не меньше {0} символов'),
  rangelength: $.validator.format(
    'Введите значение длиной от {0} до {1} символов',
  ),
  range: $.validator.format('Введите число от {0} до {1}'),
  max: $.validator.format('Максимальная длина описания - {0} символов'),
  min: $.validator.format('Введите число, большее или равное {0}'),
})

export function initValidate() {
  $('.js-validate').each((index, form) => {
    $(form).validate({
      ignore: ':hidden',
      errorElement: 'span',
      errorClass: 'form-label-error',
      onkeyup: false,
      onkeydown: false,
      rules: {
        password_confirm: {
          equalTo: '.js-password',
          minlength: 8,
        },
        reg_passConfirm: {
          equalTo: '.js-confirm',
          minlength: 8,
        },
      },

      highlight(element) {
        setTimeout(() => {
          if (!$(element).attr('disabled')) {
            $(element).parent().removeClass('is-success')
            $(element).parent().addClass('is-error')

            if (
              $(element).attr('type') === 'checkbox'
              || $(element).hasClass('select')
              || $(element).attr('type') === 'radio'
            ) {
              const parent = $(element).parent()

              parent.append(parent.find('.form-label-error'))
            }
          }
        })
      },

      unhighlight(element) {
        setTimeout(() => {
          if (!$(element).attr('disabled')) {
            if ($(element).val() !== '') {
              $(element).parent().addClass('is-success')
            }
            $(element).parent().removeClass('is-error')
          }
        })
      },
    })
  })
}

$(document).on('initValidateTrigger', () => {
  initValidate()
})

$(document).trigger('initValidateTrigger')

$(document).on('change input blur', '.form-input', (event) => {
  const currentTarget = $(event.currentTarget)
  if (currentTarget.val() === '') currentTarget.parent().removeClass('is-success')
})

$(document).on('change input blur', '.form-textarea textarea', (event) => {
  const currentTarget = $(event.currentTarget)
  currentTarget.valid()
})

$.validator.addMethod(
  'phonecustom',
  (value, element) => {
    if (!$(element).prop('required') && value === '') return true
    if (value === '+7 (___) ___-__-__') return true
    
    return value.match(/^\+7\s\([0-9]{3}\)\s[0-9]{3}\-[0-9]{2}\-[0-9]{2}$/)
  },
  'Указан неверный формат телефона',
)

$.validator.addClassRules('js-phone', {
  phonecustom: true,
})

$.validator.addMethod(
  'emailcustom',
  (value) => value.match(
    /^[=_0-9а-яА-ЯёЁa-z+~'!\$&*^`|#%\/?{}-]+(\.[=_0-9а-яА-ЯёЁa-z+~'!\$&*^`|#%\/?{}-]+)*@(([-0-9а-яА-ЯёЁa-z_]+\.)+)([а-яА-ЯёЁa-z0-9-]{2,10})$/,
  ) || value === '',
  'Введите корректный email',
)

$.validator.addClassRules('js-email', {
  emailcustom: true,
})
